import script from "./BlockViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockViewer.vue?vue&type=script&setup=true&lang=js"

import "./BlockViewer.vue?vue&type=style&index=0&id=d7475c84&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7475c84"]])

export default __exports__